module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/light-slider/slider3/slider3.component.scss
// module id = ./src/app/features/light-slider/slider3/slider3.component.scss
// module chunks = main